var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGovWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.115,
    height: 35.56,
    viewBox: "0 0 31.115 35.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-local-government",
    "data-name": "Icon map-local-government",
    d: "M34,21.463V36.28H22.883V33.317H13.252V36.28H2.88V21.463Zm-6.705-2.7a8.5,8.5,0,0,0-2.9-4.742c-1.465-1.217-3.2-1.448-5.207-2.188h-.007V7.145l.388-.1.85-.315a8.165,8.165,0,0,1,.93-.268,3.047,3.047,0,0,1,.656-.1,5.074,5.074,0,0,1,1.046.135c.421.1.869.213,1.325.338.475.144.9.253,1.31.345a4.493,4.493,0,0,0,.992.127,7.167,7.167,0,0,0,1.394-.191V1.743a5.075,5.075,0,0,1-1.394.273,4.153,4.153,0,0,1-1-.141c-.41-.079-.832-.2-1.307-.339q-.635-.191-1.284-.33a3.946,3.946,0,0,0-.948-.141,6.933,6.933,0,0,0-2.956.634V.72H17.7V11.833H17.65c-1.994.741-3.74,1.013-5.2,2.231a8.58,8.58,0,0,0-2.9,4.638,1.2,1.2,0,0,0-1.42,1.28H28.845c0-1.482-1.556-1.219-1.556-1.219Z",
    transform: "translate(-2.88 -0.72)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovWhite);
export default __webpack_public_path__ + "static/media/gov_white.4c55064a6fb660d95b20a79b72581f27.svg";
export { ForwardRef as ReactComponent };